<ng-template #userMenu let-ref>
  <section class="user-menu">
    @if (ref && !articleToCopy) {
      <div [ngClass]="{'pointer-events-none opacity-6': (ref?.status | isProductDeprecated) || thereAreDeprecatedProducts || !isEditableProject }" (click)="contextMenuAction(contextMenuActionType.COPY, ref?.uuid, $event)">
        <ng-container i18n="@@app.copy">Copy</ng-container>
      </div>
      <div [ngClass]="{'pointer-events-none opacity-6': !isEditableProject }" (click)="contextMenuAction(contextMenuActionType.DELETE, ref?.uuid)">
        <ng-container i18n="@@app.delete">Delete</ng-container>
      </div>
    }
    @if (articleToCopy) {
      <div (click)="contextMenuAction(contextMenuActionType.PASTE)">
        <ng-container i18n="@@app.paste">Paste</ng-container>
      </div>
      <div (click)="contextMenuAction(contextMenuActionType.CANCEL)">
        <ng-container i18n="@@app.cancel">Cancel</ng-container>
      </div>
    }
  </section>
</ng-template>
